<template>
	<div class="main" style="background-color: #fff;min-height: 100vh;box-sizing: border-box;">
		<hwk-header type="goodsList"></hwk-header>
		<div class="goods-filter">
			<div class="warp">
				<div class="son-nav">
					<div class="filter" v-if="show" @click="show=false"><span>收起筛选</span><i
							class="el-icon-arrow-up"></i></div>
					<div class="filter" v-else @click="show=true"><span>展开筛选</span><i class="el-icon-arrow-down"></i>
					</div>
					<div class="i flex">
						<div class="title">产品</div>
						<div class="list flex">
							<div class="item" :class="{on:index==type}" v-for="(item,index) in types" :key="index"
								@click="changeType(index)">
								{{item.title}}
							</div>
						</div>
					</div>
				</div>
				<div class="son-nav" v-if="show">
					<template v-if="type != 2">
						<div class="i flex" v-for="(item,index) in sku_data" :key="index">
							<div class="title">{{item.title}}</div>
							<div class="list flex">
								<div class="item" :class="{on:skulist[index]==item2.id}"
									v-for="(item2,index2) in item.attr_spec" :key="index2"
									@click="changesku(index,item2.id)">
									{{item2.name}}
								</div>
							</div>
						</div>
					</template>
					<div class="i flex">
						<div class="title">仓库</div>
						<div class="list flex">
							<div class="item" :class="{on:wid==item.id}" v-for="(item,index) in wlist" :key="index"
								@click="changewh(item.id)">
								{{item.name}}
							</div>
						</div>
					</div>

				</div>
			</div>

		</div>
		<div class="warp goods-warp">
			<div class="sort-nav flex">
				<div class="item" :class="{on:sort==0}" @click="changeSort(0)">综合</div>
				<div class="item" :class="{on:sort==1}" @click="changeSort(1)">销量</div>
				<div class="item" :class="{on:sort==2}" @click="changeSort(2)">单价
					<i class="el-icon-arrow-up" v-if="sonshow"></i>
					<i class="el-icon-arrow-down" v-else></i>
					<div class="ss" v-if="sonshow">
						<div class="i" @click.stop="priceChange(0)">从高到低</div>
						<div class="i" @click.stop="priceChange(1)">从低到高</div>
					</div>
				</div>
			</div>
			<div class="g-list">
				<div class="item" v-for="(item,index) in list" :key="index" @click="toDetails(item.id)">
					<div class="img">
						<img :src="http+item.image" alt="" />
					</div>
					<div class="con">
						<div class="name">{{item.title}}</div>
						<div class="price">{{getGoodsPrice(item)}}元</div>
					</div>
				</div>
			</div>
			<div class="pagination">
				<el-pagination background @current-change="handleCurrentChange" :current-page="currentPage"
					:page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<navigation :cartshow="true"></navigation>
	</div>
</template>

<script>
	import hwkHeader from './hwk-header.vue'
	import navigation from './navigation.vue'
	export default {
		components: {
			hwkHeader,
			navigation
		},
		data() {
			return {
				http: this.$imgUrl,
				sonshow: false,
				show: false,
				currentPage: 1,
				type: 0,
				types: [],
				type: 0,
				list: [],
				pageSize: 10,
				page: 1,
				sku_data: [],
				skulist: [0, 0, 0, 0, 0],
				sort: 0,
				wlist: [],
				wid: 0,
				total: 0
			};
		},
		created() {
			this.getnavlist();
			this.getlist();


		},
		computed: {
			getGoodsPrice() {
				return (data) => {
					return localStorage.getItem('userAttest') == 0 ? data.out_price : data.price
				}
			},

		},
		methods: {
			changesku(index, id) {
				this.skulist[index] = id
				console.log(this.skulist)
				this.$forceUpdate()
				this.getlist();
			},
			changewh(id) {
				if (this.wid != id) {
					this.wid = id
					this.getlist();
				}
			},


			changeType(index) {
				if (this.type != index) {
					this.type = index
					if (this.type == 2) {
						this.skulist = []
					}
					this.getlist();
				}
			},
			getnavlist() {
				this.$http.get('/api/goods/goods_option', {

				}).then(res => {
					console.log(res)
					this.types = res.data.goods_type_data
					this.types.unshift({
						id: 0,
						title: '全部'

					})
					this.sku_data = res.data.sku_data
					this.sku_data.forEach(item => {
						item.uid = 0
						item.attr_spec.unshift({
							id: 0,
							name: '全部',
							goods_attr_id: item.id,
							weigh: 0
						})
					})
					this.wlist = res.data.warehouse_data
					this.wlist.unshift({
						id: 0,
						name: '全部'

					})


				});
			},
			priceChange(i) {
				this.sonshow = false
				console.log(i)
				this.sort = i == 0 ? 2 : 3

				this.getlist();
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.currentPage = val
				this.getlist();
			},
			changeSort(index) {
				if (index == 2) {
					this.sonshow = !this.sonshow
				} else {
					this.sort = index
					this.getlist();
				}

			},
			toDetails(id) {
				this.$router.push({
					path: "/goodsDetails",
					query: {
						id: id
					}
				});
			},
			getlist() {
				this.sku_ids = this.skulist.filter(item => item > 0).toString()
				this.$http.get('/api/goods/index', {
					params: {
						page: this.currentPage,
						limit: this.pageSize,
						search: this.search,
						sku_ids: this.type == 2 ? '' : this.sku_ids,
						warehouse_ids: this.wid == 0 ? '' : this.wid,
						sort: this.sort == 3 ? -3 : (this.sort + 1), // 1=ID排序,2=销量,3=价格
						type: this.type == 0 ? '' : this.type, // 产品:1=整车,2=配件
					}

				}).then(res => {
					this.list = res.data.data
					this.total = res.data.total
				});

			},
		},
	};
</script>
<style lang="less" scoped>
	@color: #FC6E05;
	@color2: #11192D;


	.goods-filter {
		width: 100%;
		background-color: #fff;
		// padding: 20px 0;
	}

	.pagination {
		padding: 20px 0;
	}

	.sort-nav {
		margin-top: 15px;

		.item {
			font-size: 14px;
			color: #868E99;
			margin-right: 20px;
			height: 30px;
			line-height: 30px;
			display: flex;
			align-items: center;
			padding: 0 10px;
			border: 1px solid #eee;
			border-radius: 3px;
			cursor: pointer;
			position: relative;

			i {

				margin-left: 5px;
			}

			.ss {
				position: absolute;
				top: 35px;
				left: 50%;
				border: 1px solid #eee;
				background-color: #fff;
				padding: 5px;
				border-radius: 5px;
				width: 80px;
				margin-left: -40px;
				text-align: center;
				font-size: 12px;
				color: #666;
				z-index: 999;

				.i {
					line-height: 24px;

					&:hover {
						cursor: pointer;
						color: @color;
					}
				}
			}
		}

		.on {
			color: @color;
			border: 1px solid @color;
		}
	}

	.son-nav {

		position: relative;

		.filter {
			position: absolute;
			right: 20px;
			top: 10px;
			cursor: pointer;

			span {
				font-size: 14px;
				color: #666;
				margin-right: 5px;
			}
		}

		.i {
			border-bottom: 1px solid #eee;
			// padding: 10px 0;

			.title {
				color: @color2;
				font-size: 14px;
				font-weight: 600;
				width: 80px;
				text-align: left;
				line-height: 44px;
				font-family: 'AlibabaSans';
				position: relative;
				text-align-last: justify;
				text-align: justify;

				&::after {
					content: ':';
					position: absolute;
					right: -5px;
					top: 0;
					bottom: 0;
					font-size: 14px;
					color: @color2;
					font-weight: 600;
				}
			}

			.list {
				flex: 1;
				width: 1px;
				margin-left: 20px;

				.item {
					color: #666;
					font-size: 14px;
					margin-right: 30px;
					line-height: 44px;
					cursor: pointer;

					&:hover {
						color: @color;
					}
				}

				.on {
					color: @color;
				}
			}
		}
	}

	.top-nav {
		line-height: 30px;
		height: 30px;
		width: 100%;

		.item {
			color: #333;
			font-size: 16px;
			line-height: 30px;
			height: 30px;
			margin-right: 30px;
		}



		.on {
			color: @color;
		}
	}

	.g-list {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 20px;
		margin-top: 15px;

		.item {
			border: 1px solid #eee;
			background-color: #fff;
			border-radius: 10px;
			cursor: pointer;

			&:hover {
				box-shadow: 0 0 12px #ccc;
			}

			.img {
				width: 100%;
				position: relative;
				padding-top: 100%;
				height: 0;

				img {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					width: 100%;
					height: 100%;
				}
			}

			.con {
				padding: 10px;
				text-align: center;

				.name {
					font-size: 14px;
					color: #3F3F3F;
					line-height: 30px;
				}

				.price {
					font-size: 14px;
					color: @color;
					line-height: 30px;
					height: 30px;
				}

			}
		}
	}
</style>